const API = function () {
    let _registers = {};

    function register(name, func) {
        _registers[name] = func;
    }

    function call(name, params, calback) {
        if (_registers[name]) {
            try {
                _registers[name](params, calback);
            } catch (e) {
                console.warn(e);
            }
        } else {
            console.warn("the method you call is not supported.");
        }
    }

    return {
        register,
        call,
        _registers
    }
}();
export default API;
